import {ErrorBoundary as ReactErrorBoundary} from 'react-error-boundary';
import PropTypes from "prop-types";

function ErrorFallback({error, resetErrorBoundary}) {
    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
            <button onClick={resetErrorBoundary}>Try again</button>
        </div>
    );
}

ErrorFallback.propTypes = {
    error: PropTypes.object.isRequired,
    resetErrorBoundary: PropTypes.func.isRequired,
}

export const ErrorBoundary = ({children}) => {
    return (
        <ReactErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => {
                // Reset the state of your app here
            }}
            fallback={() => null}>
            {children}
        </ReactErrorBoundary>
    );
};

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,

}